"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.paperVariants = void 0;
var darkCardVariants = [
    {
        props: { variant: 'darkFlat' },
        style: function (_a) {
            var theme = _a.theme;
            return ({
                border: "1px solid var(--neutrals-300, ".concat(theme.palette.neutrals.primary, ")"),
                borderRadius: '0.5rem',
                backgroundColor: "var(--background-neutral, ".concat(theme.palette.backgrounds.neutral, ")"),
            });
        },
    },
    {
        props: { variant: 'darkFloating' },
        style: function (_a) {
            var theme = _a.theme;
            return ({
                border: "1px solid var(--neutrals-300, ".concat(theme.palette.neutrals.primary, ")"),
                borderRadius: '0.5rem',
                backgroundColor: "var(--background-neutral, ".concat(theme.palette.backgrounds.neutral, ")"),
                boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.2), 0px 3px 4px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.14)',
                '&:hover': {
                    boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.2), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 6px 10px rgba(0, 0, 0, 0.14)',
                },
            });
        },
    },
];
var whiteCardVariants = [
    {
        props: { variant: 'whiteFlat' },
        style: function (_a) {
            var theme = _a.theme;
            return ({
                border: "1px solid var(--neutrals-300, ".concat(theme.palette.neutrals.primary, ")"),
                borderRadius: '0.5rem',
                backgroundColor: "var(--background-white, ".concat(theme.palette.backgrounds.white, ")"),
            });
        },
    },
    {
        props: { variant: 'whiteFloating' },
        style: function (_a) {
            var theme = _a.theme;
            return ({
                border: "1px solid var(--neutrals-300, ".concat(theme.palette.neutrals.primary, ")"),
                borderRadius: '0.5rem',
                backgroundColor: "var(--background-white, ".concat(theme.palette.backgrounds.white, ")"),
                boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.2), 0px 3px 4px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.14)',
                '&:hover': {
                    boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.2), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 6px 10px rgba(0, 0, 0, 0.14)',
                },
            });
        },
    },
];
var lightCardVariants = [
    {
        props: { variant: 'lightFlat' },
        style: function (_a) {
            var theme = _a.theme;
            return ({
                border: "1px solid var(--neutrals-300, ".concat(theme.palette.neutrals.primary, ")"),
                borderRadius: '0.5rem',
                backgroundColor: "var(--background-light, ".concat(theme.palette.backgrounds.light, ")"),
            });
        },
    },
    {
        props: { variant: 'lightFloating' },
        style: function (_a) {
            var theme = _a.theme;
            return ({
                border: "1px solid var(--neutrals-300, ".concat(theme.palette.neutrals.primary, ")"),
                borderRadius: '0.5rem',
                backgroundColor: "var(--background-light, ".concat(theme.palette.backgrounds.light, ")"),
                boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.2), 0px 3px 4px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.14)',
                '&:hover': {
                    boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.2), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 6px 10px rgba(0, 0, 0, 0.14)',
                },
            });
        },
    },
];
exports.paperVariants = __spreadArray(__spreadArray(__spreadArray([], darkCardVariants, true), whiteCardVariants, true), lightCardVariants, true);
